module.exports = __webpack_public_path__ + "img/pointcard-bg.597a0901.png";